if (typeof ProductImageZoom !== 'function')
{
	class ProductImageZoom extends HTMLElement
	{

		constructor()
		{

			super();

			if (!document.getElementById('zoom'))
			{
				this.zoom = document.createElement('div');
				this.zoom.id = 'zoom';
				this.zoom.innerHTML = `
					<img class="zoom__exit" />					
					<span class="zoom__loader">${KROWN.settings.symbols.zoom_loader}</span>
					<div class="zoom__overlay"></div>
					<button class="zoom__prev" aria-label="Predchádzajúci obrázok" style="position:absolute;left:20px;top:50%;transform:translateY(-50%);z-index:99999;background:rgba(0,0,0,0.45);color:white;border:none;padding:12px 18px;cursor:pointer;font-size:24px;border-radius:4px;opacity:0;transition:opacity 0.3s ease;">&#8592;</button>
					<button class="zoom__next" aria-label="Nasledujúci obrázok" style="position:absolute;right:20px;top:50%;transform:translateY(-50%);z-index:99999;background:rgba(0,0,0,0.45);color:white;border:none;padding:12px 18px;cursor:pointer;font-size:24px;border-radius:4px;opacity:0;transition:opacity 0.3s ease;">&#8594;</button>
					<button class="zoom__close" aria-label="Zavrieť" style="position:fixed;top:20px;right:20px;z-index:99999;background:rgba(0,0,0,0.45);color:white;border:none;padding:10px 14px;cursor:pointer;font-size:20px;border-radius:4px;line-height:1;">&#10005;</button>
				`;

				document.body.append(this.zoom);
				this.zoom.querySelector('.zoom__exit').addEventListener('click', this._productZoomUnmount.bind(this));
				this.zoom.querySelector('.zoom__close').addEventListener('click', this._productZoomUnmount.bind(this));

				// Arrow navigation
				this.zoom.querySelector('.zoom__prev').addEventListener('click', (e) => {
					e.stopPropagation();
					this._navigateZoom('prev');
				});
				this.zoom.querySelector('.zoom__next').addEventListener('click', (e) => {
					e.stopPropagation();
					this._navigateZoom('next');
				});

				// Keyboard navigation
				window.addEventListener('keydown', (e) => {
					if (!this.zoom.classList.contains('opened')) return;
					if (e.keyCode == 37) this._navigateZoom('prev');
					if (e.keyCode == 39) this._navigateZoom('next');
				});

				// Show/hide arrows on hover (desktop)
				this.zoom.addEventListener('mouseenter', () => {
					this._updateZoomArrows();
				});
				this.zoom.addEventListener('mouseleave', () => {
					this.zoom.querySelector('.zoom__prev').style.opacity = '0';
					this.zoom.querySelector('.zoom__next').style.opacity = '0';
				});

				// Swipe gestá pre mobile
				this._swipeStartX = 0;
				this._swipeStartY = 0;
				this._isSwiping = false;
				this._isNavigating = false;

				this.zoom.addEventListener('touchstart', (e) => {
					if (this._isNavigating) return;
					this._swipeStartX = e.touches[0].clientX;
					this._swipeStartY = e.touches[0].clientY;
					this._isSwiping = false;
				}, { passive: true });

				this.zoom.addEventListener('touchmove', (e) => {
					if (this._isNavigating) return;
					const deltaX = e.touches[0].clientX - this._swipeStartX;
					const deltaY = e.touches[0].clientY - this._swipeStartY;
					if (!this._isSwiping && Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 10) {
						this._isSwiping = true;
					}
				}, { passive: true });

				this.zoom.addEventListener('touchend', (e) => {
					if (this._isNavigating || !this._isSwiping) return;
					const deltaX = e.changedTouches[0].clientX - this._swipeStartX;
					if (Math.abs(deltaX) > 50) {
						this._navigateZoom(deltaX < 0 ? 'next' : 'prev');
					}
					this._isSwiping = false;
				}, { passive: true });

			} else
			{
				this.zoom = document.getElementById('zoom');
			}

			this.onMouseMoveHandlerBinded = this.onMouseMoveHandler.bind(this);
			this.onResizeHandlerBinded = this.onResizeHandler.bind(this);

			this.addEventListener('click', (e) =>
			{
				this.zoom.classList.add('opened');
				this.image = this.zoom.querySelector('img.zoom__exit');
				this.image.src = this.getAttribute('data-image');

				this._preloadNeighbors();

				if (this.image.naturalWidth > 0)
				{
					this._productZoomMount();
				} else
				{
					this.image.addEventListener('load', this._productZoomMount.bind(this));
				}
			});

		}

		_preloadNeighbors()
		{
			const gallery = document.querySelector('.product-gallery css-slider');
			if (!gallery) return;
			const active = gallery.querySelector('.css-slide-active');
			if (!active) return;
			const slides = Array.from(gallery.querySelectorAll('.css-slide'));
			const currentIndex = slides.indexOf(active);
			[-1, 0, 1].forEach(offset => {
				const slide = slides[currentIndex + offset];
				if (!slide) return;
				const zoomEl = slide.querySelector('product-image-zoom');
				if (!zoomEl) return;
				const src = zoomEl.getAttribute('data-image');
				if (src) new Image().src = src;
			});
		}

		_updateZoomArrows()
		{
			const gallery = document.querySelector('.product-gallery css-slider');
			if (!gallery) return;
			const prevBtn = this.zoom.querySelector('.zoom__prev');
			const nextBtn = this.zoom.querySelector('.zoom__next');
			const sliderPrev = gallery.querySelector('.css-slider-prev');
			const sliderNext = gallery.querySelector('.css-slider-next');
			if (sliderPrev && sliderPrev.classList.contains('disabled')) {
				prevBtn.style.opacity = '0';
				prevBtn.style.pointerEvents = 'none';
			} else {
				prevBtn.style.opacity = '1';
				prevBtn.style.pointerEvents = 'auto';
			}
			if (sliderNext && sliderNext.classList.contains('disabled')) {
				nextBtn.style.opacity = '0';
				nextBtn.style.pointerEvents = 'none';
			} else {
				nextBtn.style.opacity = '1';
				nextBtn.style.pointerEvents = 'auto';
			}
		}

		_navigateZoom(direction)
		{
			if (this._isNavigating) return;
			this._isNavigating = true;

			const gallery = document.querySelector('.product-gallery css-slider');
			if (!gallery) {
				this._isNavigating = false;
				return;
			}

			gallery.changeSlide(direction);

			setTimeout(() => {
				const activeSlide = gallery.querySelector('.css-slide-active');
				if (activeSlide) {
					const zoomEl = activeSlide.querySelector('product-image-zoom');
					if (zoomEl) {
						const newSrc = zoomEl.getAttribute('data-image');
						if (newSrc) {
							this.image.src = newSrc;
							this._updateZoomArrows();
							this._preloadNeighbors();
						}
					}
				}
				this._isNavigating = false;
			}, 300);
		}

		onMouseMoveHandler(e)
		{
			if (window.innerWidth <= 749) return;
			window.clientX = e.clientX;
			window.clientY = e.clientY;
			this.image.style.margin = '0 auto 0 auto';
			this.image.style.right = '0px';
		}

		onResizeHandler()
		{
			if (window.innerWidth <= 749)
			{
				this.image.style.cssText = 'height:100vh;position:static;top:auto;left:auto;right:auto;margin:0;width:100vw;max-width:100vw;object-fit:contain;';
				return;
			}
			this.image.style.margin = '0 auto 0 auto';
			this.image.style.right = '0px';
			if (this.image.classList.contains('portrait'))
			{
				this.image.style.height = '100%';
			} else
			{
				this.image.style.height = '100%';
				if (this.image.offsetWidth < window.innerWidth)
				{
					this.image.style.height = '100%';
				}
			}
			const x = window.clientX * (window.innerWidth - this.image.offsetWidth) / window.innerWidth;
			const y = window.clientY * (window.innerHeight - this.image.offsetHeight) / window.innerHeight;
		}

		_productZoomMount(image)
		{
			window.addEventListener('mousemove', this.onMouseMoveHandlerBinded, { passive: true });
			this.image.dataset.ratio = this.image.naturalWidth / this.image.naturalHeight;
			window.addEventListener('resize', this.onResizeHandlerBinded, { passive: true });
			this.onResizeHandler();
			this._updateZoomArrows();

			setTimeout(() =>
			{
				if (window.innerWidth <= 749)
				{
					this.image.style.cssText = 'height:100vh;position:static;top:auto;left:auto;right:auto;margin:0;width:100vw;max-width:100vw;object-fit:contain;';
				} else
				{
					if (document.body.classList.contains('touch') || document.body.classList.contains('touchevents'))
					{
						this.zoom.scrollTop = (window.innerHeight - this.image.offsetHeight) / -2;
						this.zoom.scrollLeft = (window.innerWidth - this.image.offsetWidth) / -2;
					}
				}
				this.zoom.classList.add('loaded');
			}, 50);

			setTimeout(() =>
			{
				if (window.innerWidth <= 749)
				{
					this.image.style.cssText = 'height:100vh;position:static;top:auto;left:auto;right:auto;margin:0;width:100vw;max-width:100vw;object-fit:contain;';
				}
			}, 300);
		}

		_productZoomUnmount()
		{
			this.zoom.classList.remove('opened');
			this._isNavigating = false;

			setTimeout(() =>
			{
				window.removeEventListener('resize', this.onResizeHandlerBinded);
				window.removeEventListener('mousemove', this.onMouseMoveHandlerBinded);
				const image = document.querySelector('#zoom img');
				image.src = '';
				image.className = 'zoom__exit';
				image.style = '';
				this.zoom.classList.remove('loaded');
			}, 300);
		}

	}

	if (typeof customElements.get('product-image-zoom') == 'undefined')
	{
		customElements.define('product-image-zoom', ProductImageZoom);
	}

}
